let paidUntil=0;
export function setPremiumAccess(value){paidUntil=typeof value==='string' ? Date.parse(value) : 0;}
export function hasPremiumAccess(){return Number.isFinite(paidUntil)&&paidUntil>Date.now();}
